export default "__VITE_ASSET__cab9b563__"